// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2b291","description":"PatientConsentPreview_description__3r3ky"};